import React from "react"

import PropTypes from "prop-types"
import {Button as SemanticButton} from "semantic-ui-react"

import {getDataTestId} from "../../utils/stringUtil"

import "./button.scss"

/**
 * A button based on https://react.semantic-ui.com/elements/button.
 */
const Button = ({
    actionType,
    children = null,
    className = null,
    dataTestId,
    disabled = false,
    loading = false,
    type = "success",
    ...props
}) => {
    const dataTestAttribute = {"data-testid": dataTestId ?? getDataTestId(children, "bouton")}

    return (
        <SemanticButton
            disabled={disabled}
            loading={loading}
            className={
                (type === "danger"
                    ? "button-component-danger "
                    : type === "grey"
                    ? "button-component-grey "
                    : type === "warn"
                    ? "button-component-warn "
                    : type === "success"
                    ? "button-component-success "
                    : type === "secondary"
                    ? "button-component-secondary "
                    : "") +
                "button-component " +
                (className ? className : "")
            }
            {...props}
            {...dataTestAttribute}
            type={actionType}
        >
            {children}
        </SemanticButton>
    )
}

Button.propTypes = {
    actionType: PropTypes.oneOf(["button", "reset", "submit"]),
    children: PropTypes.any,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(["success", "danger", "grey", "warn", "primary", "secondary"]),
}

export default Button
